module.exports = __webpack_public_path__ + "img/hero-new4.d8579518.webp";